// Brokerage defaults — per PRD §9, ported verbatim from broker-team-analyzer-preview.html.
// Keep isolated from the rest of the codebase. No external imports.

export const BROKERAGES = {
  kw: {
    label: 'Keller Williams',
    defaults: {
      agent_split_pct: 64,
      annual_cap: 20000,
      post_cap_fee: 0,
      monthly_fees: 85,
      annual_eo: 300,
      is_kw: true,
      kw_royalty_cap: 3000,
    },
    note:
      'Defaults typical for a major KW market center. Cap and fees vary by MC — confirm with your sponsor. Includes 6% royalty capped at $3,000/yr.',
  },
  exp: {
    label: 'eXp Realty',
    defaults: {
      agent_split_pct: 80,
      annual_cap: 16000,
      post_cap_fee: 285,
      monthly_fees: 85,
      annual_eo: 40,
    },
    note:
      'Published 80/20 split, $16k cap, $285 post-cap transaction fee. Rev-share and stock available behind toggle.',
  },
  real: {
    label: 'Real Brokerage',
    defaults: {
      agent_split_pct: 85,
      annual_cap: 12000,
      post_cap_fee: 285,
      monthly_fees: 0,
      annual_eo: 62,
    },
    note:
      '85/15 split to $12k cap; post-cap $285 fee. $750 annual fee modeled as $62/mo E&O equivalent.',
  },
  realty_one: {
    label: 'Realty ONE Group',
    defaults: {
      agent_split_pct: 100,
      annual_cap: 0,
      post_cap_fee: 195,
      monthly_fees: 50,
      annual_eo: 300,
    },
    note:
      '100% commission model — agent keeps 100%, pays a per-transaction fee. Defaults are placeholders; varies widely by region.',
  },
  custom: {
    label: 'Custom brokerage',
    defaults: {
      agent_split_pct: 80,
      annual_cap: 15000,
      post_cap_fee: 0,
      monthly_fees: 0,
      annual_eo: 0,
    },
    note:
      'Blank template — fill in the splits and fees your brokerage charges.',
  },
};

export const MONTHS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];
